import React, { useEffect, useRef, useState } from 'react';
import { Breadcrumb, Button, Col, Row, Select, Switch, ProgressProps, Progress } from 'antd';
import { connect } from 'react-redux';
import { getGeiYearsByOrganizationId, getCategoriesByOrganizationIdAndYear, getCategoriesByOrganizationUnifiedIdAndYear } from 'src/store/Results/thunks';
import { getAllOrganization } from 'src/store/organization/thunks';
import { getUserByToken, getUserByTokenAll } from 'src/store/user/thunks';
import { AppState } from 'src/store';
import { Organization } from '../../../store/organization/types';
import { CategoryResponse, CategoryResults, ResultsResponse } from 'src/store/Results/types';
import style from './Results.module.scss';
import styles from 'src/globals/Layout/Admin/AdminHeader.module.scss';
import { useHistory, useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';
import { Bar, Doughnut } from 'react-chartjs-2';
import ResultsHeader from './ResultsHeader';
import { FileExcelOutlined } from '@ant-design/icons';
interface ResultProps {
    getGeiYearsByOrganizationId?: any;
    getCategoriesByOrganizationIdAndYear?: any;
    getAllOrganization?: any;
    getUserByTokenAll?: any;
    getCategoriesByOrganizationUnifiedIdAndYear?: any;
}




const Results: React.FC<ResultProps> = (props: ResultProps) => {
    const [emissionSChart, setEmissionSChart] = useState([]);
    const [emissiontco2eChart, setEmissiontco2eChart] = useState([]);
    const [dataEmissionChart, setDataEmissionChart] = useState([]);
    const [nameChart, setNameChart] = useState([]);
    const [dataChart, setDataChart] = useState([]);
    const [isYearSelected, setIsYearSelected] = useState(false);
    const [organization, setOrganization] = useState([]);
    const history = useHistory();
    const [typeOrganization, setTypeOrganization] = useState("");
    const [typeYears, setTypeYears] = useState("");
    const [category, setCategory] = useState([]);
    const [isNone, setIsNone] = useState("-none");
    const [results, setResults] = useState<ResultsResponse>();
    const [pieChartData, setPieChartData] = useState<any>(null);
    const { Option } = Select;
    interface RouteParams {
        type: string
    }
    const params = useParams<RouteParams>();
    const [year, setDataYears] = useState([]);
    const chartRef = useRef<HTMLCanvasElement | null>(null); // Ref para el lienzo del gráfico

    const init = async () => {
        const responseUser = await props.getUserByTokenAll();
        if (responseUser.rol === "administrator" || responseUser.rol == "super_admin") {
            const responseDataOrganization = await props.getAllOrganization();
            setOrganization(responseDataOrganization);
        } else if (responseUser.rol === "client") {           
           
        }
    };

    useEffect(() => {
        init();
    }, []);


    const handleChangeTypeOrganization = async (value: any) => {
        setTypeOrganization(value);
        setIsNone("-none");
        const responseData = await props.getGeiYearsByOrganizationId(value);
        if (responseData !== undefined) {
            setDataYears(responseData);
        } else {
            setDataYears([]);
            setIsNone("-none");
            setTypeYears("");
        }
    };
    const handleChangeTypeYears = async (value: any) => {
        setTypeYears(value);
        const responseData = await props.getCategoriesByOrganizationIdAndYear(typeOrganization, value);
        if (responseData != undefined) {
            setIsNone("")
            setCategory(responseData.categoryResponse);
            setResults(responseData);
        }

        setIsNone("");
        setCategory(responseData.categoryResponse);
        setResults(responseData);
        setIsYearSelected(true);
        const emissionS = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => result.emissionSource)//Fuentes de Emision
        );

        const emissiontco2e = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => result.tCO2e)//Fuentes de Emision
        );

        console.log(emissionS)
        const dataEmission = responseData.categoryResponse.flatMap((category: any) =>
            category.categoryResults.map((result: any) => parseFloat(result.tcO2e)));

        const dataEmissionInteger = dataEmission.map((value: number) => Math.floor(value));

        console.log(dataEmissionInteger)
        console.log(dataEmission)
        setEmissionSChart(emissionS);
        setDataEmissionChart(dataEmission);
        setEmissiontco2eChart(emissiontco2e);

        //obtenemos las categorias para la seccion 2
        const names = responseData.categoryResponse.map((item: any) => item.name);
        console.log(names)
        //obtenemos los valores de tCo2e para la seccion 2
        const data = responseData.categoryResponse.map((item: any) => item.totalinput);
        setNameChart(names);
        setDataChart(data);
    };
    const randomColor = () => '#' + Math.floor(Math.random() * 16777215).toString(16);
    const backgroundColors = dataEmissionChart.map(() => randomColor());
    const conicColors: ProgressProps['strokeColor'] = {
        '0%': '#87d068',
        '50%': '#ffe58f',
        '100%': '#ffccc7',
      };

    let dataBar1 = {
        labels: emissionSChart,
        datasets: [
            {
                label: 'Fuentes de Emisión X tCO2e:',
                data: dataEmissionChart,
                backgroundColor: backgroundColors
            },
        ],
    };
    const options = {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 100, 
                    max: 10000,
                },
            },
        },
        plugins: {
            legend: {
                display: false
            },
        },
    };

    let dataPie2 = {
        labels: nameChart,
        datasets: [
            {
                data: dataChart
            },
        ],
    };
    let dataBar2 = {
        labels: nameChart,
        datasets: [
            {
                label: 'TOTAL CO2e(t)',
                data: dataChart
            },
        ],
    };

    useEffect(() => {
        if (chartRef.current && pieChartData) {
            const ctx = chartRef.current.getContext('2d');
            if (ctx) {
                new Chart(ctx, {
                    type: 'doughnut', // Cambia el tipo de gráfico según tus necesidades
                    data: pieChartData,
                });
            }
        }
    }, [pieChartData]);

    return (
        <div>
            <ResultsHeader annual={"-bold"} mensual={""} history={""} />

            <Row justify="center" style={{ width: "100%" }}>
                <Col lg={2}></Col>
                <Col lg={8}>
                    Escoga la organización:
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeOrganization}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeOrganization}
                        placeholder="Escoga la organización"
                    >
                        {organization.map((type: Organization) => (
                            <Option key={`type-option-${type}`} value={type.id}
                            >
                                {type.ruc + "-" + type.name}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col lg={4}>
                    Escoga el año
                    <Select

                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeYears}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeYears}
                        placeholder="Escoga el año"
                    >
                        {year.map((type: string) => (
                            <Option key={`type-option-${type}`} value={type}
                            >
                                {type}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col lg={2}></Col>
            </Row>
            <Row justify={"end"}>
                <Col>
                <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                        //onClick={handleExportToExcel}
                    >
                        Exportar a Excel
                    </Button>

                </Col>

            </Row>

            <div className={style["title-reults"]} >
                1. DECLARACIÓN DE EMISIONES DE GEI POR ESTABLECIMIENTO
            </div>
            <Row justify="start" className={style["custom-row" + isNone]}>
                <Col lg={4}>
                    Establecimiento                        </Col>
                <Col lg={4}>
                    Fuente de emisión
                </Col>
                <Col lg={3}>
                    Flujo de Fuente
                </Col>
                <Col lg={2}>
                    t CO₂
                </Col>
                <Col lg={2}>
                    t CH₄
                </Col>
                <Col lg={2}>
                    t N₂O
                </Col>
                <Col lg={2}>
                    t HFC
                </Col>
                <Col lg={2}>
                    t CO₂e
                </Col>
                <Col lg={2}>
                    Aporte%
                </Col>

            </Row>
            {category.map((type: CategoryResponse) => (
                <div key={type.id} >
                    {type.categoryResults.map((type: CategoryResults) => (
                        <div key={type.establisment} >
                            <Row justify="start" className={style["custom-row-data" + isNone]}>
                                <Col lg={4}>
                                    {type.establisment}
                                </Col>
                                <Col lg={4}>
                                    {type.emissionSource}
                                </Col>
                                <Col lg={3}>
                                    {type.flow}
                                </Col>
                                <Col lg={2}>
                                    {type.tco2}
                                </Col>
                                <Col lg={2}>
                                    {type.tch4}
                                </Col>
                                <Col lg={2}>
                                    {type.tn26}
                                </Col>
                                <Col lg={2}>
                                    {type.thfc}
                                </Col>
                                <Col lg={2}>
                                    {type.tcO2e}
                                </Col>
                                <Col lg={2}>
                                    {type.input + "%"}
                                </Col>
                            </Row>
                        </div>

                    ))}

                    <Row justify="start" className={style["custom-row-total" + isNone]}>
                        <Col lg={11}>
                            {"Categoria " + type.type + " (" + type.name + ")"}
                        </Col>
                        <Col lg={2}>
                            {type.totaltco2}
                        </Col>
                        <Col lg={2}>
                            {type.totaltch4}
                        </Col>
                        <Col lg={2}>
                            {type.totaltn2o}
                        </Col>
                        <Col lg={2}>
                            {type.totalthfc}
                        </Col>
                        <Col lg={2}>
                            {type.totaltco2e}
                        </Col>
                        <Col lg={2}>
                            <div>
                                <Progress type="dashboard" percent={Number.parseInt(type.totalinput)} strokeColor={conicColors} />   
                            </div>
                                                       
                        </Col>
                    </Row>


                </div>
            ))}
            <Row justify="start" className={style["custom-row-total" + isNone]}>
                <Col lg={11}>
                    Total Emisiones CO₂e (t)
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontch4}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontn2o}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissionthfc}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissiontco2e}
                </Col>
                <Col lg={2}>
                    {results?.totalEmissioninput + "%"}
                </Col>
            </Row>
            <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                <Col lg={12}>
                    Emisiones biogénicas por combustión de biomasa CO₂ (t)
                </Col>
                <Col lg={12}>
                    {results?.totalEmissionBiomasa}
                </Col>


            </Row>
            <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                <Col lg={12}>
                    Emisiones HCFC
                </Col>
                <Col lg={12}>
                    {results?.totalHcfc}
                </Col>
            </Row>
            <div className={style["title-reults"]} >
                2. HUELLA DE CARBONO POR CATEGORÍA
            </div>
            <Row justify="start" className={style["custom-row" + isNone]}>
                <Col lg={8}>
                    Categoria
                </Col>
                <Col lg={8}>
                    TOTAL CO₂e (t)
                </Col>
                <Col lg={8}>
                    Aporte %
                </Col>
            </Row>
            {category.map((type: CategoryResponse) => (
                <Row justify="start" className={style["custom-row-data" + isNone]}>
                    <Col lg={8}>
                        {"Categoria " + type.type + " (" + type.name + ")"}
                    </Col>
                    <Col lg={8}>
                        {type.totaltco2e}
                    </Col>
                    <Col lg={8}>
                        {type.totalinput + "%"}
                    </Col>
                </Row>
            ))}
            {isYearSelected
                ?
                <div className={style["chart-reultsPie"]}>
                    <Doughnut data={dataPie2} />
                </div>
                :
                <div>
                </div>}

            <div className={style["title-reults"]} >
                3. MATERIALIDAD
            </div>
            <Row justify="start" className={style["custom-row" + isNone]}>
                <Col lg={4}>
                    Fuente de emisión
                </Col>
                <Col lg={4}>
                    Flujo de Fuente
                </Col>
                <Col lg={4}>
                    Categoria
                </Col>
                <Col lg={4}>
                    t CO₂e
                </Col>
                <Col lg={4}>
                    Aporte %
                </Col>
            </Row>
            {category.map((cat: CategoryResponse) => (
                <div>
                    {cat.categoryResults.map((type: CategoryResults) => (
                        <div key={type.establisment} >
                            <Row justify="start" className={style["custom-row-data" + isNone]}>
                                <Col lg={4}>
                                    {type.emissionSource}
                                </Col>
                                <Col lg={4}>
                                    {type.flow}
                                </Col>
                                <Col lg={4}>
                                    {cat.type}
                                </Col>
                                <Col lg={4}>
                                    {type.tcO2e}

                                </Col>
                                <Col lg={4}>
                                    {type.input + "%"}

                                </Col>
                            </Row>
                        </div>

                    ))}
                </div>
            ))}
            {isYearSelected
                ?
                <div className={style["chart-reultsBar"]}>
                    <Bar data={dataBar1} options={options} />
                </div>
                :
                <div>
                </div>}
        </div>

    );
    { }
};
const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getGeiYearsByOrganizationId, getCategoriesByOrganizationIdAndYear, getCategoriesByOrganizationUnifiedIdAndYear,
    getAllOrganization, getUserByTokenAll
})(Results);